/* B3 AIR storefront JS — small, dependency-free */
(function () {
  'use strict';
  document.documentElement.classList.add('b3-js');
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Cart drawer ---------- */
  var drawer = $('#B3Drawer');
  var lastFocus = null;
  function openDrawer() {
    if (!drawer) { window.location.href = root + 'cart'; return; }
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('b3-lock');
    var c = $('.b3-drawer__close', drawer); if (c) c.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('b3-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function refreshDrawer() {
    return fetch(root + '?sections=b3-cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data && data['b3-cart-drawer'];
        if (!html || !drawer) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.b3-drawer__inner');
        var cur = $('.b3-drawer__inner', drawer);
        if (fresh && cur) cur.replaceWith(fresh);
        var count = fresh ? fresh.getAttribute('data-count') : null;
        if (count !== null) $$('[data-b3-count]').forEach(function (el) { el.textContent = count; el.setAttribute('data-count', count); });
        document.dispatchEvent(new CustomEvent('b3:cart', { detail: { count: +count } }));
      });
  }
  function cartAdd(items, btn) {
    if (btn) btn.classList.add('is-loading');
    return fetch(root + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to bag'); return j; });
    }).then(function () { return refreshDrawer(); })
      .then(openDrawer)
      .catch(function (e) {
        if (!btn) return;
        var n = btn.parentNode.querySelector('.b3-err') || document.createElement('p');
        n.className = 'b3-err'; n.setAttribute('role', 'alert'); n.textContent = e.message;
        n.style.cssText = 'margin:8px 0 0;font-size:13px;color:#a3332b';
        btn.insertAdjacentElement('afterend', n);
      })
      .finally(function () { if (btn) btn.classList.remove('is-loading'); });
  }
  function cartChange(key, qty) {
    var inner = $('.b3-drawer__inner', drawer); if (inner) inner.style.opacity = '.6';
    return fetch(root + 'cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(refreshDrawer).catch(function () { window.location.href = root + 'cart'; });
  }
  window.B3 = { openCart: openDrawer, closeCart: closeDrawer, add: cartAdd, refresh: refreshDrawer };

  document.addEventListener('click', function (e) {
    var t = e.target;
    var add = t.closest('[data-b3-add]');
    if (add) {
      e.preventDefault();
      try { cartAdd(JSON.parse(add.getAttribute('data-b3-add')), add); } catch (err) { window.location.href = add.getAttribute('href') || root + 'cart'; }
      return;
    }
    if (t.closest('[data-b3-open-cart]')) { e.preventDefault(); openDrawer(); return; }
    if (t.closest('[data-b3-close-cart]')) { e.preventDefault(); closeDrawer(); return; }
    if (drawer && drawer.classList.contains('is-open') && !t.closest('.b3-drawer__panel')) { closeDrawer(); return; }
    var q = t.closest('[data-b3-line-qty]');
    if (q) { e.preventDefault(); cartChange(q.getAttribute('data-key'), parseInt(q.getAttribute('data-b3-line-qty'), 10)); return; }
    var nav = t.closest('[data-b3-nav]');
    if (nav) {
      e.preventDefault();
      var m = $('#B3MobileNav'); if (!m) return;
      var open = nav.getAttribute('data-b3-nav') === 'open';
      m.classList.toggle('is-open', open);
      m.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.body.classList.toggle('b3-lock', open);
      return;
    }
    if (t.closest('#B3MobileNav a')) { var mn = $('#B3MobileNav'); mn.classList.remove('is-open'); document.body.classList.remove('b3-lock'); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); var m = $('#B3MobileNav'); if (m) { m.classList.remove('is-open'); document.body.classList.remove('b3-lock'); } }
  });

  /* ---------- Product form ---------- */
  var form = $('[data-b3-product-form]');
  if (form) {
    var qtyInput = $('input[name="quantity"]', form);
    var price = parseInt(form.getAttribute('data-price'), 10) || 0;
    var tiers = $$('[data-b3-qty]');
    var label = $('[data-b3-atc-label]');
    var hint = $('[data-b3-hint]');
    var money = function (p) { return '£' + (p / 100).toFixed(2); };
    var setQty = function (n) {
      n = Math.max(1, Math.min(99, n || 1));
      qtyInput.value = n;
      tiers.forEach(function (b) { b.setAttribute('aria-pressed', String(+b.getAttribute('data-b3-qty') === n)); });
      var free = Math.floor(n / 3), disc = price * (n - free);
      if (label) label.textContent = 'Add to bag — ' + money(disc);
      if (hint) hint.textContent = n >= 3 ? free + ' free can' + (free > 1 ? 's' : '') + ' applied automatically at checkout. Free UK delivery unlocked.' : 'Add ' + (3 - n) + ' more can' + (3 - n > 1 ? 's' : '') + ' (any scent) and get 1 free + free UK delivery.';
    };
    tiers.forEach(function (b) { b.addEventListener('click', function () { setQty(+b.getAttribute('data-b3-qty')); }); });
    $$('[data-b3-step]', form).forEach(function (b) { b.addEventListener('click', function () { setQty((parseInt(qtyInput.value, 10) || 1) + (+b.getAttribute('data-b3-step'))); }); });
    qtyInput.addEventListener('change', function () { setQty(parseInt(qtyInput.value, 10)); });
    setQty(parseInt(qtyInput.value, 10) || 1);
    form.addEventListener('submit', function (e) {
      if (!drawer) return;
      e.preventDefault();
      var id = $('[name="id"]', form).value;
      cartAdd([{ id: +id, quantity: parseInt(qtyInput.value, 10) || 1 }], $('[type="submit"]', form));
    });
    var sticky = $('#B3Sticky'), atc = $('#B3MainAtc');
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var e0 = en[0];
        sticky.classList.toggle('is-on', !e0.isIntersecting && e0.boundingClientRect.top < 0);
      }).observe(atc);
      var sb = $('button', sticky); if (sb) sb.addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : $('[type="submit"]', form).click(); });
    }
  }

  /* ---------- Gallery ---------- */
  $$('[data-b3-gallery]').forEach(function (g) {
    var track = $('.b3-gallery__track', g), thumbs = $$('.b3-gallery__thumb', g), dots = $$('.b3-gallery__dots span', g);
    var set = function (i) {
      thumbs.forEach(function (t, j) { t.setAttribute('aria-current', String(i === j)); });
      dots.forEach(function (d, j) { d.classList.toggle('is-on', i === j); });
    };
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' }); set(i); }); });
    var tm; track.addEventListener('scroll', function () { clearTimeout(tm); tm = setTimeout(function () { set(Math.round(track.scrollLeft / track.clientWidth)); }, 60); }, { passive: true });
  });

  /* ---------- Scent filters ---------- */
  $$('[data-b3-filters]').forEach(function (wrap) {
    var scope = document.getElementById(wrap.getAttribute('data-b3-filters'));
    $$('[data-filter]', wrap).forEach(function (chip) {
      chip.addEventListener('click', function () {
        var f = chip.getAttribute('data-filter');
        $$('[data-filter]', wrap).forEach(function (c) { c.setAttribute('aria-pressed', String(c === chip)); });
        $$('[data-scent]', scope).forEach(function (el) { el.hidden = f !== 'all' && el.getAttribute('data-scent') !== f; });
      });
    });
  });

  /* ---------- Header + reveal ---------- */
  var hdr = $('.b3-header');
  if (hdr) window.addEventListener('scroll', function () { hdr.classList.toggle('is-scrolled', window.scrollY > 8); }, { passive: true });
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
    $$('.b3-reveal').forEach(function (el) { io.observe(el); });
  } else { $$('.b3-reveal').forEach(function (el) { el.classList.add('is-in'); }); }

  /* ---------- Newsletter feedback ---------- */
  if (/customer_posted=true/.test(location.search)) { var nm = $('[data-b3-news-msg]'); if (nm) nm.hidden = false; }
})();
